import React from 'react';

export const LocalizationContext = React.createContext({
    currencyCode: 'USD',
    language: 'en-US',
});
